export const FETCH_LABELS_AND_PLACEHOLDER = "FETCH_LABELS_AND_PLACEHOLDER";
export const FETCH_LABELS_AND_PLACEHOLDER_SUCCESS =
  "FETCH_LABELS_AND_PLACEHOLDER_SUCCESS";
export const FETCH_LABELS_AND_PLACEHOLDER_FAILED =
  "FETCH_LABELS_AND_PLACEHOLDER_FAILED";
